var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { RicosPluginToolbarNames } from "./../ricos-types";
import { DEFAULTS } from "./defaults";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { InsertModal } from "./modals/InsertModal";
import { SettingsModal } from "./modals/SettingsModal";
import { tiptapExtensions } from "./tiptap/tiptap";
import { VIDEO_TYPE } from "./types";
const pluginVideo = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: VIDEO_TYPE,
    tiptapExtensions,
    getAddButtons,
    toolbar: {
      names: [RicosPluginToolbarNames.VIDEO],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    __exports: { SettingsModal, InsertModal }
  };
};
export {
  pluginVideo
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
